import { makeReadScope, type AssetReadScope, type BaseAssetManager } from '@gotti/core';

export interface ClientAssetsFacade {
  client: AssetReadScope;
}

export function makeClientAssetsFacade(mgr: BaseAssetManager): ClientAssetsFacade {
  return { client: makeReadScope(mgr, 'client') };
}
